/**
 * Утиліти для роботи з пагінацією
 */

import { DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "@/config";

/**
 * Обчислює загальну кількість сторінок
 */
export function calculateTotalPages(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

/**
 * Нормалізує номер сторінки (ціле, мінімум 1).
 *
 * `?page=abc` used to come back as NaN (`Math.max(1, NaN)` is NaN), which
 * reached the list loaders as a NaN offset and the page's canonical as
 * `?page=NaN`; `?page=2.5` came back as 2.5.
 */
export function normalizePage(page: number | string | undefined): number {
  const parsedPage = typeof page === "string" ? Number(page) : (page ?? 1);
  return Number.isFinite(parsedPage) ? Math.max(1, Math.floor(parsedPage)) : 1;
}

type PageSizeParam = string | string[] | number | undefined | null;

export function normalizePageSize(value: PageSizeParam): number {
  const raw = Array.isArray(value) ? value[0] : value;

  const parsed =
    typeof raw === "number" ? raw : typeof raw === "string" ? Number(raw) : NaN;

  if (!Number.isFinite(parsed) || parsed <= 0) {
    return DEFAULT_PAGE_SIZE;
  }

  const clamped = Math.min(Math.floor(parsed), MAX_PAGE_SIZE);
  const allowed = new Set<number>(PAGE_SIZE_OPTIONS as unknown as number[]);

  // Дозволяємо тільки варіанти з селектора (або MAX_PAGE_SIZE для "all").
  if (allowed.has(clamped) || clamped === MAX_PAGE_SIZE) {
    return clamped;
  }

  return DEFAULT_PAGE_SIZE;
}
